import { render, staticRenderFns } from "./wordAudio.vue?vue&type=template&id=48f5486c&scoped=true"
import script from "./wordAudio.vue?vue&type=script&lang=js"
export * from "./wordAudio.vue?vue&type=script&lang=js"
import style0 from "./wordAudio.vue?vue&type=style&index=0&id=48f5486c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f5486c",
  null
  
)

export default component.exports